export default __webpack_public_path__ + "static/media/Gustavo.01b17014.jpeg";